import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-scroll';
import '../styles/components/newHeader.scss';

export default function NewHeader() {
	const [open, setOpen] = useState(false);
	const history = useHistory();
	const [scrollPos, setScrollPos] = useState(0);
	const [scrollDir, setScrollDir] = useState(false);
	const [isPageTop, setPageTop] = useState(true);
	const [isMobile, setMobile] = useState(false);

	const waitForHomePage = (to: string) => {
		history.push('/');
		const timer = setInterval(() => {
			const url = window.location.href;
			if (
				url === 'http://localhost:3000/' ||
				url === 'http://0.0.0.0:3000/' ||
				url === 'https://yoursocial1.netlify.app/'
			) {
				clearInterval(timer);
				const section = document.querySelector(`#${to}`);
				section?.scrollIntoView({
					behavior: 'smooth',
					block: 'start',
					inline: 'nearest',
				});
				setOpen(false);
				// return to;
			}
		}, 100);
	};

	window.onscroll = function () {
		const currPos = window.pageYOffset;
		// console.log(currPos);
		if (currPos < 40) {
			setScrollDir(false);
		} else if (scrollPos < currPos && !open) {
			setScrollDir(true);
		} else {
			setScrollDir(false);
		}
		setScrollPos(window.pageYOffset);
	};
	useEffect(() => {
		scrollPos > 40 ? setPageTop(false) : setPageTop(true);
	}, [scrollPos]);

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;
			setMobile(width > 768 ? false : true);
		};
		handleResize();
		window.addEventListener('resize', handleResize, false);
	}, []);

	return (
		<div
			className={
				!isMobile && isPageTop
					? 'nav pageTop'
					: scrollDir
					? 'nav moving-down'
					: 'nav'
			}
		>
			<div className='container'>
				<div className='logo'>Webbler</div>
				<div className={open ? 'links-wrapper active' : 'links-wrapper'}>
					<div className='link'>
						<Link
							activeClass='active'
							to={'onboarding'}
							spy={true}
							smooth={true}
							duration={300}
							onClick={() => waitForHomePage('onboarding')}
						>
							Home
							<div className='underline'></div>
						</Link>
					</div>
					<div className='link'>
						<Link
							activeClass='active'
							to='featuresSection'
							spy={true}
							smooth={true}
							duration={300}
							onClick={() => waitForHomePage('featuresSection')}
						>
							Features
							<div className='underline'></div>
						</Link>
					</div>
					<div className='link'>
						<Link
							activeClass='active'
							to='vipSection'
							spy={true}
							smooth={true}
							duration={300}
							onClick={() => waitForHomePage('vipSection')}
						>
							VIPs
							<div className='underline'></div>
						</Link>
					</div>
					<div className='link'>
						Contact<div className='underline'></div>
					</div>
					<button
						className='white-button link'
						onClick={() => {
							history.push('/login');
						}}
					>
						Sign In
					</button>
				</div>
				<button
					className={open ? 'burger-menu active-menu' : 'burger-menu'}
					onClick={() => setOpen(!open)}
				>
					<div className='line'></div>
					<div className='line middle'></div>
					<div className='line'></div>
				</button>
			</div>
		</div>
	);
}
